module.exports = __webpack_public_path__ + "img/dental3.34efce16.jpeg";